var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    dragging: _vm.itemId === _vm.draggingId,
    'not-dragging': _vm.draggingId !== null && _vm.itemId !== _vm.draggingId
  }},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }